import { makeStyles } from "@material-ui/core/styles";

const useAmortizationTableStyles = makeStyles({
  table: {
    minWidth: 650
  },
  header: {
    backgroundColor: "#F5F5F5",
    fontWeight: "bold"
  },
  cell: {
    border: "1px solid #ddd",
    padding: "8px"
  }
});

export default useAmortizationTableStyles;
